import React from "react";
import { footerLink } from "../constants/footerLink";

const Footer = () => {
  return (
    <footer className="mb-3">
      <div className="flex items-center justify-between max-w-6xl mx-auto">
        {footerLink?.map((item, index) => (
          <a
            href={item?.link}
            className="block w-full font-bold text-center"
            key={index}
            target="_blank"
          >
            {item?.title}
          </a>
        ))}
      </div>
    </footer>
  );
};

export default Footer;
